module.exports = __webpack_public_path__ + "images/d6ac314ad9035a0defc3a3f8a317312b.png";